import React, {useEffect, useState} from "react";
import Lotto5Nav from "./Lotto5Nav";
import DatePicker from "react-datepicker";
import {useDispatch, useSelector} from "react-redux";
import {fetchLotto5WinLossReport} from "../../store/rootAction";
import moment from "moment";
import "moment-timezone";
import {useTranslation} from "react-i18next";
import {currentDate, getDateDef} from "../../utils/dateUtils";
import MainTableWinReport from "./MainTableWinReport";

export default function Lotto5WinReport(props) {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const winReport = useSelector(state => state.lotto5.winReport)


    // Local state
    const [date, setDate] = useState(currentDate());

    // Fetch on mount
    useEffect(() => {
        onFilter();
        // eslint-disable-next-line
    }, []);

    const onFilter = (params = {}) => {
        dispatch(fetchLotto5WinLossReport({...winReport.filter, filterDate: getDateDef(date), ...params}));
    };


    return (
        <div className="main-w">
            <div className="main">
                <div className="w-1200">
                    <div className="wrapper-game-content">
                        <Lotto5Nav/>
                        <div className="fade-in">
                            <div className="row align-items-center ml-3 mt-2 pb-0">
                                <div className="form-date-range">
                                    <label>{t("labels:drawing.date")}:</label>
                                </div>
                                <div className="pl-2">
                                    <DatePicker
                                        dateFormat="dd-MM-yyyy"
                                        selected={date}
                                        maxDate={moment().toDate()}
                                        onChange={setDate}
                                        className="form-control bg-white"
                                    />
                                </div>
                                <div className="wrap-btn-filter">
                                    <button className="btn-game" onClick={() => onFilter()}>
                                        {t("labels:common.getResult")}
                                    </button>
                                </div>
                            </div>
                            <MainTableWinReport onChangPage={onFilter} {...winReport}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
